export default __webpack_public_path__ + "static/media/Kids_Corner.603b02cc.png";